// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related-companies-container {
  min-height: var(--sebrae-full-height);
  padding: 24px 0;
  color: var(--sebrae-gray);
  position: relative;
  display: flex;
  flex-direction: column;
}
.related-companies-container .container {
  flex: 1 1;
}
.related-companies-container .salutation {
  font-size: 20px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
  line-height: 1.2;
  margin-bottom: 20px;
}
.related-companies-container .description-companies {
  color: var(--sebrae-gray);
  font-size: 16px;
  line-height: 1.4;
}
.related-companies-container .description-companies.color-desktop {
  color: var(--sebrae-dark-gray3);
}
.related-companies-container .available-companies {
  display: flex;
  flex-wrap: wrap;
  margin: 15px 0 0;
  gap: 16px;
}
.related-companies-container .shared-access {
  max-width: 1040px;
  min-height: calc(var(--sebrae-full-height) - 180px);
  display: flex;
  flex-direction: column;
}
.related-companies-container .shared-access__title {
  font-family: Figtree;
  font-size: 23px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--sebrae-dark-gray3);
}
.related-companies-container .shared-access__description {
  font-size: 16px;
  margin-bottom: 8px;
  color: var(--sebrae-dark-gray3);
}
.related-companies-container .shared-access__layout {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 28px;
}
.related-companies-container .shared-access__companies {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 420px;
}
.related-companies-container .shared-access__companies .card-input-company {
  max-width: 100%;
  min-height: auto;
}
.related-companies-container .shared-access__card {
  width: 100%;
  max-width: 319px;
  background: #EFF6FF;
  border-radius: 5px;
  border: 1px solid #BEDBFF;
  padding: 16px;
}
.related-companies-container .shared-access__card h4 {
  color: #1C398E;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 12px;
}
.related-companies-container .shared-access__card ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.related-companies-container .shared-access__card li {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  color: #364153;
  font-size: 13px;
  line-height: 1.4;
}
.related-companies-container .shared-access__card li img {
  width: 12px;
  height: 12px;
  flex: 0 0 12px;
  margin-top: 2px;
}
.related-companies-container .shared-access__divider {
  width: 100%;
  height: 1px;
  background: #c7ddff;
  margin-bottom: 14px;
}
.related-companies-container .shared-access__actions {
  margin-top: auto;
  padding-top: 40px;
}
.related-companies-container .company__register__area {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 38px;
  width: 100%;
  max-width: 221px;
  margin: 0 auto;
}
.related-companies-container .company__register__area .text-or {
  padding: 20px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.related-companies-container .company__register__area .text-or span {
  position: absolute;
  font-size: 13px;
  color: var(--sebrae-gray);
  padding: 0 12px;
  line-height: 1.2;
  background: var(--sebrae-white);
}
.related-companies-container .company__register__area .text-or:after {
  content: "";
  width: 100%;
  border-bottom: 1px solid var(--sebrae-light-gray4);
}
.related-companies-container .company__register__area .BaSe--button,
.related-companies-container .company__register__area .btn-white-outline {
  width: 100%;
}
.related-companies-container .company__register__area .BaSe--button span,
.related-companies-container .company__register__area .btn-white-outline span {
  font-size: 13px;
}
.related-companies-container .company__bottom__content {
  width: 100%;
  background: var(--sebrae-white);
  position: sticky;
  left: 0;
  z-index: 0;
  bottom: 0;
  padding: 15px 0;
}
.related-companies-container .company__bottom__content .container {
  display: flex;
  flex-direction: column;
}
.related-companies-container .company__bottom__content .read-terms {
  display: flex;
  align-items: center;
}
.related-companies-container .company__bottom__content .read-terms .BaSe--checkbox div:last-child {
  width: 16px;
  height: 16px;
  border: 1px solid var(--sebrae-blue-2);
}
.related-companies-container .company__bottom__content .read-terms .BaSe--checkbox label {
  font-size: 13px;
  line-height: 1.2;
  padding-top: 2px;
}
.related-companies-container .company__bottom__content .read-terms .underlined-term {
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
}
.related-companies-container .company__bottom__content .company__button {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 16px;
}
.related-companies-container .company__bottom__content .company__button-continue {
  margin-left: auto;
}
.related-companies-container .company__bottom__content .company__button .BaSe--button {
  min-width: 147px;
}
@media screen and (min-width: 768px) {
  .related-companies-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .related-companies-container .salutation {
    font-size: 26px;
    margin-bottom: 16px;
  }
  .related-companies-container .available-companies {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .related-companies-container .available-companies .card-input-company {
    max-width: 100%;
  }
  .related-companies-container .shared-access__layout {
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
  }
  .related-companies-container .shared-access__actions {
    padding-top: 56px;
  }
  .related-companies-container .company__bottom__content {
    position: relative;
  }
  .related-companies-container .company__bottom__content .company__button {
    padding-top: 32px;
  }
  .related-companies-container .company__bottom__content .company__button-continue {
    margin-left: 0;
  }
  .related-companies-container .company__register__area button {
    font-weight: 400;
    font-size: 16px !important;
  }
  .related-companies-container .company__register__area button span {
    font-weight: 400;
    font-size: 16px !important;
  }
}
@media screen and (min-width: 1200px) {
  .related-companies-container {
    padding: 65px 0;
  }
  .related-companies-container .salutation {
    font-size: 32px;
  }
  .related-companies-container .available-companies {
    grid-template-columns: 343px 343px 343px;
  }
  .related-companies-container .shared-access {
    padding-left: 12px;
  }
  .related-companies-container .shared-access__layout {
    gap: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/companies/index.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EACE,SAAA;AACJ;AACE;EAEI,eAAA;EACA,gBAAA;EAEF,2BAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAGE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGI;EACE,+BAAA;AADN;AAIE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAFJ;AAIE;EACE,iBAAA;EACA,mDAAA;EACA,aAAA;EACA,sBAAA;AAFJ;AAIE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;AAFJ;AAIE;EACE,eAAA;EACA,kBAAA;EACA,+BAAA;AAFJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAFJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAFJ;AAII;EACE,eAAA;EACA,gBAAA;AAFN;AAKE;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AAHJ;AAKI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAMI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAJN;AAOI;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AALN;AAOM;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AALR;AASE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAPJ;AASE;EACE,gBAAA;EACA,iBAAA;AAPJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAPJ;AASI;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAPN;AASM;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAPR;AASM;EACE,WAAA;EACA,WAAA;EACA,kDAAA;AAPR;AAUI;;EAEE,WAAA;AARN;AAUM;;EACE,eAAA;AAPR;AAWE;EACE,WAAA;EACA,+BAAA;EACA,gBAAA;EACA,OAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AATJ;AAWI;EACE,aAAA;EACA,sBAAA;AATN;AAWI;EACE,aAAA;EACA,mBAAA;AATN;AAaU;EACE,WAAA;EACA,YAAA;EACA,sCAAA;AAXZ;AAcQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAZV;AAgBM;EACE,0BAAA;EACA,eAAA;EACA,cAAA;AAdR;AAiBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AAfN;AAiBM;EACE,iBAAA;AAfR;AAiBM;EACE,gBAAA;AAfR;AAoBE;EAvNF;IAwNI,aAAA;IACA,sBAAA;IACA,8BAAA;EAjBF;EAmBE;IACE,eAAA;IACA,mBAAA;EAjBJ;EAmBE;IACE,aAAA;IACA,8BAAA;IACA,SAAA;EAjBJ;EAmBI;IACE,eAAA;EAjBN;EAoBE;IACE,mBAAA;IACA,uBAAA;IACA,SAAA;EAlBJ;EAoBE;IACE,iBAAA;EAlBJ;EAoBE;IACE,kBAAA;EAlBJ;EAoBI;IACE,iBAAA;EAlBN;EAoBM;IACE,cAAA;EAlBR;EAuBI;IACE,gBAAA;IACA,0BAAA;EArBN;EAuBM;IACE,gBAAA;IACA,0BAAA;EArBR;AACF;AAyBE;EAxQF;IAyQI,eAAA;EAtBF;EAwBE;IACE,eAAA;EAtBJ;EAwBE;IACE,wCAAA;EAtBJ;EAwBE;IACE,kBAAA;EAtBJ;EAwBE;IACE,SAAA;EAtBJ;AACF","sourcesContent":[".related-companies-container {\n  min-height: var(--sebrae-full-height);\n  padding: 24px 0;\n  color: var(--sebrae-gray);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  .container {\n    flex: 1;\n  }\n  .salutation {\n    font: {\n      size: 20px;\n      weight: 700;\n    }\n    color: var(--sebrae-blue-6);\n    line-height: 1.2;\n    margin-bottom: 20px;\n  }\n  .description-companies {\n    color: var(--sebrae-gray);\n    font-size: 16px;\n    line-height: 1.4;\n\n    &.color-desktop {\n      color: var(--sebrae-dark-gray3);\n    }\n  }\n  .available-companies {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 15px 0 0;\n    gap: 16px;\n  }\n  .shared-access {\n    max-width: 1040px;\n    min-height: calc(var(--sebrae-full-height) - 180px);\n    display: flex;\n    flex-direction: column;\n  }\n  .shared-access__title {\n    font-family: Figtree; \n    font-size: 23px;\n    font-weight: 700;\n    margin-bottom: 8px;\n    color: var(--sebrae-dark-gray3);\n  }\n  .shared-access__description {\n    font-size: 16px;\n    margin-bottom: 8px;\n    color: var(--sebrae-dark-gray3);\n  }\n  .shared-access__layout {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    margin-top: 28px;\n  }\n  .shared-access__companies {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    max-width: 420px;\n\n    .card-input-company {\n      max-width: 100%;\n      min-height: auto;\n    }\n  }\n  .shared-access__card {\n    width: 100%;\n    max-width: 319px;\n    background: #EFF6FF;\n    border-radius: 5px;\n    border: 1px solid #BEDBFF;\n    padding: 16px;\n\n    h4 {\n      color: #1C398E;\n      font-size: 20px;\n      font-weight: 700;\n      line-height: 1.2;\n      margin-bottom: 12px;\n    }\n\n    ul {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    li {\n      display: flex;\n      align-items: flex-start;\n      gap: 6px;\n      color: #364153;\n      font-size: 13px;\n      line-height: 1.4;\n\n      img {\n        width: 12px;\n        height: 12px;\n        flex: 0 0 12px;\n        margin-top: 2px;\n      }\n    }\n  }\n  .shared-access__divider {\n    width: 100%;\n    height: 1px;\n    background: #c7ddff;\n    margin-bottom: 14px;\n  }\n  .shared-access__actions {\n    margin-top: auto;\n    padding-top: 40px;\n  }\n  .company__register__area {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding-top: 38px;\n    width: 100%;\n    max-width: 221px;\n    margin: 0 auto;\n\n    .text-or {\n      padding: 20px 0;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n\n      span {\n        position: absolute;\n        font-size: 13px;\n        color: var(--sebrae-gray);\n        padding: 0 12px;\n        line-height: 1.2;\n        background: var(--sebrae-white);\n      }\n      &:after {\n        content: \"\";\n        width: 100%;\n        border-bottom: 1px solid var(--sebrae-light-gray4);\n      }\n    }\n    .BaSe--button,\n    .btn-white-outline {\n      width: 100%;\n\n      span {\n        font-size: 13px;\n      }\n    }\n  }\n  .company__bottom__content {\n    width: 100%;\n    background: var(--sebrae-white);\n    position: sticky;\n    left: 0;\n    z-index: 0;\n    bottom: 0;\n    padding: 15px 0;\n\n    .container {\n      display: flex;\n      flex-direction: column;\n    }\n    .read-terms {\n      display: flex;\n      align-items: center;\n\n      .BaSe--checkbox {\n        div {\n          &:last-child {\n            width: 16px;\n            height: 16px;\n            border: 1px solid var(--sebrae-blue-2);\n          }\n        }\n        label {\n          font-size: 13px;\n          line-height: 1.2;\n          padding-top: 2px;\n        }\n      }\n\n      .underlined-term {\n        text-decoration: underline;\n        cursor: pointer;\n        color: inherit;\n      }\n    }\n    .company__button {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      padding-top: 16px;\n\n      &-continue {\n        margin-left: auto;\n      }\n      .BaSe--button {\n        min-width: 147px;\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    .salutation {\n      font-size: 26px;\n      margin-bottom: 16px;\n    }\n    .available-companies {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 16px;\n\n      .card-input-company {\n        max-width: 100%;\n      }\n    }\n    .shared-access__layout {\n      flex-direction: row;\n      align-items: flex-start;\n      gap: 24px;\n    }\n    .shared-access__actions {\n      padding-top: 56px;\n    }\n    .company__bottom__content {\n      position: relative;\n\n      .company__button {\n        padding-top: 32px;\n\n        &-continue {\n          margin-left: 0;\n        }\n      }\n    }\n    .company__register__area {\n      button {\n        font-weight: 400;\n        font-size: 16px !important;\n\n        span {\n          font-weight: 400;\n          font-size: 16px !important;\n        }\n      }\n    }\n  }\n  @media screen and (min-width: 1200px) {\n    padding: 65px 0;\n\n    .salutation {\n      font-size: 32px;\n    }\n    .available-companies {\n      grid-template-columns: 343px 343px 343px;\n    }\n    .shared-access {\n      padding-left: 12px;\n    }\n    .shared-access__layout {\n      gap: 32px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
